<div mat-dialog-title class="modal-header">
  <div class="row">
    <div class="col-md-12">
  {{ title }}
    </div>
  </div>
  </div>
<form novalidate [formGroup]="confirmForm">
<div mat-dialog-content class="modal-body">
    <div class="mrgn-bttm-lg term_container" [ngSwitch]="termsOption">
		<carm-api-download-terms *ngSwitchCase="'api-download'"></carm-api-download-terms>
		<carm-offsetting-terms *ngSwitchCase="'business-settings'"></carm-offsetting-terms>
		<carm-disbursments-terms *ngSwitchCase="'disbursments'"></carm-disbursments-terms>
		<carm-recourse-terms *ngSwitchCase="'recourse'"></carm-recourse-terms>
	</div>
    <p class="mrgn-tp-md mrgn-bttm-md">
        <strong><u>{{ certifyTitle }}</u></strong>
    </p>
    <div class="checkbox-container mrgn-tp-md">
        <mat-checkbox
            formControlName="iCertify"
            id="iCertify"
			data-cy="iCertify"
            color="primary"
            aria-label="{{ certifyText }}"></mat-checkbox>
        <strong class="checkbox-label-span">
         {{ certifyText }}
        </strong>
    </div>
</div>
<div class="modal-footer">
	<div class="row">
		<div class="col-md-4 col-sm-4">
			<carm-button
				id="accept"
				data-cy="accept"
				btnLabel="{{ 'button.accept' | translate }}"
				[btnTypeDefault]="true"
				[btnStretch]="true"
				[spaceTop]="true"
				customClass="btn-primary"
				(click)="accept()"
                [disabled]="!confirmForm?.value?.iCertify"
				>
            </carm-button>
		</div>
		<div class="col-md-4 col-sm-4">
			<carm-button
				id="cancel"
				data-cy="cancel"
				btnLabel="{{ 'button.cancel' | translate }}"
				[btnTypeDefault]="true"
				[btnStretch]="true"
				[spaceTop]="true"
				(click)="cancel()"
			>
			</carm-button>
		</div>
		<div class="col-md-4"></div>
	</div>
</div>
</form>
